(async function () {
    const WRAPPER = document.querySelector('#productsSwiper .swiper-wrapper');
    if (!WRAPPER) return;

    // 1) Load data
    let slides = [];
    try {
        const res = await fetch('/data/products-data.json', { cache: 'no-cache' });
        slides = await res.json();
        if (!Array.isArray(slides)) throw new Error('JSON must be an array');
    } catch (e) {
        console.error('Failed to load /data/products-data.json', e);
        return;
    }

    // 2) Render slides
    const frag = document.createDocumentFragment();
    for (const s of slides) {
        const { title = '', desc = '', mainImg = '', zoomImg = '', ctaHref = '#', features = [] } = s;
        const f1 = features[0] ?? '';
        const f2 = features[1] ?? '';
        const f3 = features[2] ?? '';

        const slide = document.createElement('div');
        slide.className = 'swiper-slide flex md:flex-row flex-col md:items-center w-full md:px-0 px-4';

        slide.innerHTML = `
        <div class="md:w-1/2 w-full relative">
          <img class="mx-auto" src="${mainImg}" alt="${escapeHtml(title)}" loading="lazy" />
          <button class="btn-zoom absolute bottom-0 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 w-[66px]"
                  data-zoom="${zoomImg}"
                  aria-label="Zoom image: ${escapeHtml(title)}">
            <img class="w-[50px] aspect-square" src="/img/circle-search.svg" alt="Icon" />
            <p class="text-xs">Детальніше</p>
          </button>
        </div>
  
        <div class="md:w-1/2 w-full flex flex-col gap-11">
          <h3 class="md:text-4xl text-3xl font-playfair uppercase md:mt-0 mt-10">${escapeHtml(title)}</h3>
          <p class="font-helvetica-light">${escapeHtml(desc)}</p>
  
          <div class="flex md:flex-row flex-col md:gap-0 gap-5 justify-between text-sm">
            ${renderFeature('/img/ico-1.svg', escapeHtml(f1))}
            ${renderFeature('/img/ico-2.svg', escapeHtml(f2), true)}
            ${renderFeature('/img/ico-3.svg', escapeHtml(f3))}
          </div>
  
          <a class="w-[230px] h-[45px] flex items-center justify-center text-black bg-white border-white border-[1px] hover:bg-c-black hover:text-white"
             href="${ctaHref}">
             Переглянути більше
          </a>
        </div>
      `;
        frag.appendChild(slide);
    }
    WRAPPER.appendChild(frag);

    /* ===== Hook into already created Swiper + force update after dynamic render ===== */
    const nextBtn = document.querySelector('.swiper-button-next');
    const nextImg = nextBtn?.querySelector('.js-next-img');
    const nextTitle = nextBtn?.querySelector('.js-next-title');
    const nextCount = nextBtn?.querySelector('.js-next-count');

    function safeIndex(sw) {
        // Safely read current index
        if (Number.isInteger(sw?.realIndex)) return sw.realIndex;
        if (Number.isInteger(sw?.activeIndex)) return sw.activeIndex;
        return 0;
    }

    function updateNextButton(sw) {
        if (!nextBtn || !Array.isArray(slides) || !slides.length || !sw) return;

        // Ensure button is never stuck disabled by Swiper
        nextBtn.classList.remove('swiper-button-disabled');
        nextBtn.removeAttribute('aria-disabled');
        nextBtn.style.pointerEvents = 'auto';

        const total = slides.length;
        const curr = safeIndex(sw);
        const next = (curr + 1) % total;
        const sNext = slides[next] || {};

        const imgSrc = sNext.nextThumb || sNext.mainImg || '';
        const title = sNext.title || '';
        const count = `${next + 1} / ${total}`;

        if (nextImg) {
            nextImg.src = imgSrc;
            nextImg.alt = title;
        }
        if (nextTitle) nextTitle.textContent = title;
        if (nextCount) nextCount.textContent = count;

        // Prefetch next preview image
        if (imgSrc) {
            const i = new Image();
            i.src = imgSrc;
        }
    }

    function attachHandlers(sw) {
        // Fill button immediately
        updateNextButton(sw);

        // Keep button text fresh and unlocked on any change
        sw.on('slideChange', () => updateNextButton(sw));
        sw.on('transitionEnd', () => updateNextButton(sw));
        sw.on('loopFix', () => updateNextButton(sw));
        sw.on('resize', () => updateNextButton(sw));

        // Our own click handler: always works (no passive listener, no preventDefault)
        nextBtn?.addEventListener('click', () => {
            if (!sw || sw.animating) return;
            if (sw.params.loop) {
                sw.slideNext();
            } else {
                if (sw.isEnd) sw.slideTo(0, sw.params.speed || 600);
                else sw.slideNext();
            }
        });
    }

    if (typeof swiper !== 'undefined' && swiper) {
        // Swiper was created before slides were injected → we must update it
        if (swiper.params.loop) {
            // Properly rebuild loop clones
            swiper.loopDestroy();
            swiper.update();
            swiper.loopCreate();
            swiper.slideToLoop(0, 0); // jump to first "real" slide
        } else {
            swiper.update();
            swiper.slideTo(0, 0);
        }
        attachHandlers(swiper);
    } else {
        console.error('swiper not found. Include this file AFTER new Swiper(...) or expose it as window.swiper.');
    }

    // 3) Zoom modal
    const modal = document.getElementById('zoomModal');
    const zoomImgEl = document.getElementById('zoomImgEl');
    const closeBtn = document.getElementById('zoomCloseBtn');

    function openZoom(src) {
        if (!src) return;
        zoomImgEl.src = src;
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        document.documentElement.style.overflow = 'hidden';
        const img = new Image();
        img.src = src; // preload
    }
    function closeZoom() {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        zoomImgEl.src = '';
        document.documentElement.style.overflow = '';
    }

    WRAPPER.addEventListener('click', (e) => {
        const btn = e.target.closest('.btn-zoom');
        if (!btn) return;
        openZoom(btn.getAttribute('data-zoom'));
    });

    modal.addEventListener('click', (e) => {
        const clickedBackdrop = e.target === modal || e.target.closest('#zoomModal > .absolute.inset-0');
        const clickedClose = e.target === closeBtn;
        if (clickedBackdrop || clickedClose) closeZoom();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeZoom();
    });

    // helpers
    function renderFeature(iconSrc, text, allowTwoLines = false) {
        const labelHtml = allowTwoLines ? text.replace(/\sяк\sінгредієнт\s№1/i, 'як <br />інгредієнт №1') : text;
        return `
        <div class="flex md:flex-col flex-row gap-2.5 md:items-start items-center">
          <div class="flex flex-col gap-2.5 items-start">
            <img loading="lazy" class="w-8 aspect-square" src="${iconSrc}" alt="Icon" />
            <div class="w-10 h-[1px] bg-white"></div>
          </div>
          <p>${labelHtml}</p>
        </div>`;
    }

    function escapeHtml(str = '') {
        return String(str).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
    }
})();
